var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-educations',{attrs:{"cate-code":_vm.cateCode,"cate-name":_vm.cateName}})
}
var staticRenderFns = []

export { render, staticRenderFns }